import { ViewHandleEventFn } from '@angular/core/src/view';

export class PopupConfig<D = any,pname=string,List=any,vW = number, vH = number> {
  data?: D;
  pageName?: pname;
  list?: List;
  vW?: vW;
  vH?: vH;
}
